module.exports = __webpack_public_path__ + "img/pitching4.ae607697.png";